<div class="form-group" [formGroup]="customFormGroup">
	<label [for]="'select-'+id" [id]="'sfklabel-'+id" data-cy="custom-label">
		{{ label }}
	</label>
  <fa-icon class="infoIcon"
           *ngIf="!!infoText && infoText.length > 0"
           [icon]="faInfo"
           [title]="infoText"
           data-cy="custom-info"
  ></fa-icon>
  <span *ngIf="environment.displayTextbausteinKeys">{{infoText}}</span>
	<ng-select
		[labelForId]="'select-' + id"
		[attr.aria-label]="'Select Box ' + id"
		[items]="items"
		[bindLabel]="bindLabel"
		[bindValue]="bindValue"
		[multiple]="multiple"
		[closeOnSelect]="!multiple"
		[searchable]= "searchable"
    [clearable]= "clearable"
		[placeholder]="placeholder"
		[formControlName]="id"
	  [readonly]="readonly ? true : null"
    [notFoundText]="notfoundtext"
    [loading]="loading"
    [loadingText]="loadingText"
    [hideSelected]="hideSelected"
    [virtualScroll]="true"
    (change)="triggerOnChange($event)"
    (search)="triggerSearch($event)"
    (scrollToEnd)="triggerScrollToEnd($event)"
    (open)="triggerOpen($event)"
    (clear)="triggerOnClear()"
	  data-cy="custom-select"
	>

<!--	 Template to display currently selected item (single select)-->
    <ng-template ng-label-tmp let-item="item">
  <!--		 if template given, display via custom template, otherwise display item[bindLabel] by default-->
      <span *ngIf="!customStringTemplate" class="ng-value-label">
        <span [attr.aria-label]="item[bindLabel]" [title]="item[bindLabel]">
          <!--render the actual label as defined by template below-->
          <ng-container *ngTemplateOutlet="bindlabeltemplate; context: { item: item }"></ng-container>
        </span>
      </span>
      <span *ngIf="customStringTemplate" class="ng-value-label" [attr.aria-label]="item[bindLabel]" [title]="item[bindLabel]">
        <ng-container *ngTemplateOutlet="customStringTemplate; context: { item: item }"></ng-container>
      </span>
    </ng-template>

<!--	 Template to display currently selected items (multi select)-->
    <ng-template *ngIf="this.placeholderAlwaysVisible===true" ng-multi-label-tmp let-items="items">
      <div class="ng-value" *ngFor="let item of items ">
        <span class="ng-value-icon right" (click)="clearItem(item)" aria-hidden="true">×</span>
		<!-- if template given, display via custom template, otherwise display item[bindLabel] by default -->
        <span *ngIf="!customStringTemplate" class="ng-value-label">
          <span [attr.aria-label]="item[bindLabel]" [title]="item[bindLabel]">
            <!--render the actual label as defined by template below-->
            <ng-container *ngTemplateOutlet="bindlabeltemplate; context: { item: item }"></ng-container>
          </span>
        </span>
        <span *ngIf="customStringTemplate" class="ng-value-label" [attr.aria-label]="item[bindLabel]" [title]="item[bindLabel]">
          <ng-container *ngTemplateOutlet="customStringTemplate; context: { item: item }"></ng-container>
        </span>
      </div>
      <div class="ng-value" style="background: none;">
        <span class="ng-value-label text-muted">{{this.placeholder}}</span>
      </div>
    </ng-template>

  <!--	 Template to display Option items inside the dropdown (applied for both, multi select and single select)-->
    <ng-template ng-option-tmp let-item="item">
  <!--		 if template given, display via custom template, otherwise display item[bindLabel] by default-->
      <span *ngIf="!customStringTemplate" class="ng-value-label">
        <span [attr.aria-label]="item[bindLabel]" [title]="item[bindLabel]">
          <!--render the actual label as defined by template below-->
          <ng-container *ngTemplateOutlet="bindlabeltemplate; context: { item: item }"></ng-container>
        </span>
      </span>
      <span *ngIf="customStringTemplate" class="ng-value-label" [attr.aria-label]="item[bindLabel]" [title]="item[bindLabel]">
        <ng-container *ngTemplateOutlet="customStringTemplate; context: { item: item }"></ng-container>
      </span>
    </ng-template>

  </ng-select>


  <!--  the following template is used to render the actual label-->
  <ng-template #bindlabeltemplate let-item="item">
<!--      FIXME : I could be wrong, but something seems off here -->
<!--      1) this seems to be a basic 'html copy' of ng-select's typed logic - why not let ng-select handle it?-->
<!--      2) a significant amount of fallbacks and error handling done by ngselect is missing here-->
<!--      3) this is in conflict with ng-select's placeholder, "nothing selected" becomes indistinguishable from "null/undefined selected" -->
<!--      4) "missing list item value" becomes indistinguishable from "value is there but label is missing"-->
<!--      5) we're using UntypedFormGroup, a FormControl meant for numbers or Objects might be re-typed to string,-->
<!--         when a null or undefined number/Object gets replaced with "-"-->
    <span [ngSwitch]="getDataType(item)" [attr.aria-label]="item[bindLabel]" [title]="item[bindLabel]">
      <ng-container *ngSwitchCase="'null'">{{ "-" }}</ng-container> <!-- this might pass string value "-" into a FromControl meant for (nullable) number or Object -->
      <ng-container *ngSwitchCase="'undefined'">{{ "-" }}</ng-container> <!-- this might pass string value "-" into a FromControl meant for (nullable) number or Object -->
      <ng-container *ngSwitchCase="'string'">{{item === "" ? "-" : item}}</ng-container>
      <ng-container *ngSwitchCase="'number'">{{item}}</ng-container>
      <ng-container *ngSwitchDefault>
        <span [ngSwitch]="getDataType(item[bindLabel])">
          <ng-container *ngSwitchCase="'null'">{{ "-" }}</ng-container> <!-- label "-" will imply null/undefined value, where value is actually present -->
          <ng-container *ngSwitchCase="'undefined'">{{ "-" }}</ng-container> <!-- label "-" will imply null/undefined value, where value is actually present -->
          <ng-container *ngSwitchCase="'string'">{{item[bindLabel] === "" ? "-" : item[bindLabel]}}</ng-container> <!-- label "-" will imply null/undefined value, where value is actually present -->
          <ng-container *ngSwitchCase="'number'">{{item[bindLabel]}}</ng-container>
          <ng-container *ngSwitchDefault>
            <!--fallbacks-->
            {{
              (
                !!item["value"] ? item["value"] : (
                  !!item["name"] ? item["name"] : (
                    !!item ? item : (
                      item
                    )
                  )
                )
              )
            }}
          </ng-container>
        </span>
      </ng-container>
    </span>
  </ng-template>
	<small
		*ngIf="isInvalid()"
		[id]="id + '-help-block'"
		class="form-text text-muted"
	>
		{{ noteText }}
	</small>
  <p *ngIf="!!infoTextBelowInput && infoTextBelowInput.length > 0">
    {{ infoTextBelowInput }}
  </p>
</div>
